import { useTranslation } from 'react-i18next';

import { parseDate } from '../../../containers/campaigns/utils/helpers';

export const useGetTileText = ({
  tileCount,
  publishDate,
  currentPosition,
  tileStatus,
  postId,
}) => {
  const { t } = useTranslation('tileForm');
  const tileData = { tileCount, position: currentPosition + 1 };
  const scheduledTileData = {
    ...tileData,
    publishDate: parseDate(publishDate, t('tileActionMenu.dateFallback')),
  };

  if (postId) {
    return t('tileActionMenu.scheduledTiles', scheduledTileData);
  }

  if (tileStatus === 'user_submitted') {
    return t('tileActionMenu.suggestedTiles', tileData);
  }

  return t('tileActionMenu.unscheduledTiles', tileData);
};
